import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {Skeleton, Tabs} from 'antd';

import CarGeneralInfo from './CarGeneralInfo';
import DetailsScreenHeader from '../../../components/detailsScreenHeader/DetailsScreenHeader';
import ErrorBoundary from '../../../components/ErrorBoundary';
import {messageType, showMessages} from '../../../helpers/message';
import {useGetCarQuery} from '../../../store/api/carsApi';
import PageTitle from '../../../components/page/PageTitle';
import Error404 from '../../../components/errors/404';

import {CarOutlined} from '@ant-design/icons';

const CarManage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const id = new URLSearchParams(location.search).get('id');
    const {data: car, isLoading, isError} = useGetCarQuery(Number(id));

    React.useEffect(() => {
        if (isError) {
            showMessages('Car not found', messageType.error);
        }
    }, [isError]);

    const onClickBack = () => {
        const {state} = location;
        if (!state) {
            navigate(-1);
            return;
        }

        if (state && state.page && state.perPage) {
            navigate('/fleet/car/list', {
                state: {page: state.page, perPage: state.perPage},
            });
        } else {
            navigate('/fleet/car/list');
        }
    }
    const tabsItems = [
        {
            label: 'General Info',
            key: '1',
            children: (
                <ErrorBoundary>
                    <CarGeneralInfo car={car} isStaff={false} isLoading={isLoading}/>
                </ErrorBoundary>
            ),
        },
    ];

    if (isLoading || !car) {
        return <Skeleton active loading={isLoading}/>;
    }

    return (
        isError ? <Error404/> :
            <>
                <PageTitle title="Vehicle Details" icon={<CarOutlined/>}/>
                <DetailsScreenHeader car={car} onClickBack={onClickBack}/>
                <Tabs defaultActiveKey="1" items={tabsItems}/>
            </>
    );
};

export default CarManage;